import { AlwaysonEnvironmentInterface } from '../app/interface/alwayson-environment.interface';

export const environment: AlwaysonEnvironmentInterface = {
  production: true,
  gmapsKey: 'AIzaSyC5D2NkJHmHFgRgG8RP3ZnR7aQl2D-7tT0',
  domain: 'preprod-alwayson.integrix.lu',
  env: 'preprod',
  mobileUrl: 'https://preprod-alwayson.integrix.lu/mobile',

  api: {
    apiEndPoint: 'api/',
    settingsApi: 'auth/settings',
  },
  app: {
    appId: '71522bb7-eb78-4258-9657-588b05847918',
    defaultRoute: 'activity',
    appName: 'Always-On',
    lang: ['fr', 'de'],
    cache: 0,
  },
  auth: {
    loginUrl: 'api/auth-default',
    initApi: '/init',
    logoutUrl: 'api/auth/logout',
    azure: {
      tenant: 'o365.infodata.lu',
      logoutUri: 'https://preprod-alwayson.integrix.lu/logout',
      client: '1ab0c7d0-9cba-4569-ab50-cea719fc647c',
      redirectUri: 'https://preprod-alwayson.integrix.lu/oauth2',
      api: 'auth/auth-azure',
    },
    google: {
      client:
        '289749081264-i7mffa8es1fhi7o1hn2q4nln57g4l57l.apps.googleusercontent.com',
      redirectUri: 'https://preprod-alwayson.integrix.lu/oauth2',
      api: 'auth/auth-google',
    },
  },
  login: {
    loginRoute: 'login',
    defaultConnection: true,
    resetRequest: 'auth/reset-request',
    resetPassword: 'auth/reset-password',
  },
  ui: {
    exportLogoPath:
      'https://assets.integrix.lu/img/logos/integrix-always-on.png',
    appLogoPath: 'https://assets.integrix.lu/img/logos/integrix-always-on.svg',
    companyLogoPath: 'https://assets.integrix.lu/img/logos/infodata.svg',
    lockerBackgroundPath:
      'https://assets.integrix.lu/img/backgrounds/2025.webp',
  },
  changelog: {
    enable: true,
    endpoint:
      'https://preprod-changelogs.integrix.lu/api/versions?&WITH=product|=|AO-WEB]',
    route: 'changelogs',
  },
};
